import React from 'react';
import 'bootstrap/dist/js/bootstrap.bundle.min.js'; 

const faqData = [
  {
    question: "What Role Does a Logo Play As A Part Of Your Brand's Identity?",
    answer: "A logo is the face of your brand. It visually represents your business, builds trust, and creates a strong first impression. A great logo communicates your values, tone, and professionalism at a glance.",
    id: 1,
  },
  {
    question: "What Effect Does Color Selection Have On Your Logo Design?",
    answer: "Colors evoke emotions and perceptions. The right palette can make your brand feel trustworthy, exciting, luxurious, or eco-friendly. We use color psychology to ensure your logo resonates with your target audience.",
    id: 2,
  },
  {
    question: "How Long Will It Take to Get a New Website?",
    answer: "Website timelines vary from service to service. A basic site usually takes a minimum of a week or less, but on the other hand, an advanced project may take more than that. We always try to work with a mutual deadline!",
    id: 3,
  },
  {
    question: "How Much Does a Custom Website Cost?",
    answer: "It all depends on your needs and what type of website you are aiming for. Our basic website starts around $450 but with a 50% Flat discount you would only have to pay $225. With more complex builds, the prices may rise.",
    id: 4,
  },
];

const FAQSection = () => {
  return (
    <section id="id_faq_section" className="faq_section section_space pb-0 position-relative z-2">
      <div className="container">
        <div className="memecoin_heading_block text-center" data-aos="fade-up" data-aos-duration="800">
          <h2 className="heading_text text-uppercase mb-0">FAQ</h2>
        </div>

        <div className="row">
          <div className="col-lg-6">
            <div className="meme_accordion" id="accordion_1">
              {faqData.slice(0, 2).map((faq, index) => (
                <div className="accordion-item" data-aos="fade-up" data-aos-duration="800" data-aos-delay={`${100 * (index + 1)}`} key={faq.id}>
                  <div className="accordion-button collapsed" role="button" data-bs-toggle="collapse" data-bs-target={`#collapse_${faq.id}`} aria-expanded="false" aria-controls={`collapse_${faq.id}`}>
                    <span className="icon">
                      <i className="fa-solid fa-plus"></i>
                    </span>
                    {faq.question}
                  </div>
                  <div id={`collapse_${faq.id}`} className="accordion-collapse collapse" data-bs-parent="#accordion_1">
                    <div className="accordion-body">
                      <p className="mb-0">{faq.answer}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="col-lg-6">
            <div className="meme_accordion" id="accordion_2">
              {faqData.slice(2).map((faq, index) => (
                <div className="accordion-item" data-aos="fade-up" data-aos-duration="800" data-aos-delay={`${100 * (index + 1)}`} key={faq.id}>
                  <div className="accordion-button collapsed" role="button" data-bs-toggle="collapse" data-bs-target={`#collapse_${faq.id}`} aria-expanded="false" aria-controls={`collapse_${faq.id}`}>
                    <span className="icon">
                      <i className="fa-solid fa-plus"></i>
                    </span>
                    {faq.question}
                  </div>
                  <div id={`collapse_${faq.id}`} className="accordion-collapse collapse" data-bs-parent="#accordion_2">
                    <div className="accordion-body">
                      <p className="mb-0">{faq.answer}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
